'use strict';
const Backbone = require('backbone');
const _ = require('underscore');

module.exports = Backbone.Model.extend({
    defaults: {
        source: null,
        target: null,
        deleted: false
    },

    isDeleted: function() {
        return this.get('deleted');
    },

    getSource: function() {
        return this.get('source');
    },

    getTarget: function() {
        return this.get('target');
    }
});



// WEBPACK FOOTER //
// ./process/domain/entity/action/transition.js